import React, { useRef, useState, useLayoutEffect } from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import listPlugin from '@fullcalendar/list';
import { Card, CardBody } from 'reactstrap';
import { useSanitaryAgenda } from '../../../hooks/sanitary/useSanitaryAgenda';
import { SidebarDiary } from './SidebarDiary';
import esLocale from '@fullcalendar/core/locales/es';
import '../../sanitary/micSampling/styleMicDiary.css'
import { CustomAlertDialogGlobal } from '../../alertDialog/CustomAlertDialogGlobal';
import { ToastAletGlobal } from '../../alertDialog/ToastAletGlobal';


export const IndexMicDiary = () => {
    const {
        calendarRef, selectedEvent, selectedDate, panelMode, sidebarVisible,
        currentView, calendarTitle, search, setSearch, loading,
        filteredEvents, dayEvents, statistics, changeView, navigate,
        openDayList, openDetails, selectEvent, backToList,
        closeSidebar, applyEventColor, renderEventCard, renderListCard, handleEventDrop,
         startSampling, formatDate,
        formatLongDate, getEventData, isPastDate, fetchQuotations,
        lastRangeRef, setCalendarTitle, setCurrentView, views,
        
        //? CUSTOM ALERT
        customAlert,

        //? TOAST ALERT
        showToast,
        toastType,
        toastTitle,
        toastMessage,
        closeToastAlert,

        //? HISTORIAL
        sanitaryHistorical,
        loadingHistorical,
        historicalError,

        
    } = useSanitaryAgenda();

    const agendaContainerRef = useRef(null);
    const [agendaHeight, setAgendaHeight] = useState(null);

    useLayoutEffect(() => {
        const container = agendaContainerRef.current;
        if (!container) return;

        const updateHeight = () => {
            const rect = container.getBoundingClientRect();

            const scaleY = container.offsetHeight > 0
                ? rect.height / container.offsetHeight
                : 1;

            const availableHeight = Math.max(
                0,
                Math.floor(
                    (window.innerHeight - rect.top - 4) / (scaleY || 1)
                )
            );

            setAgendaHeight(previous =>
                previous === availableHeight
                    ? previous
                    : availableHeight
            );
        };

        updateHeight();

        const observer = new ResizeObserver(updateHeight);

        if (container.parentElement) {
            observer.observe(container.parentElement);
        }

        window.addEventListener('resize', updateHeight);

        return () => {
            observer.disconnect();
            window.removeEventListener('resize', updateHeight);
        };
    }, []);

    return (
        <div ref={agendaContainerRef} className="sanitaryAgenda container-global-zoom" style={
                agendaHeight !== null
                    ? { height: `${agendaHeight}px` }
                    : { height: 'calc(100dvh - 180px)' }
            }
        >

            <Card className="sanitaryAgenda-main-header">
                <CardBody>
                    <div className="sanitaryAgenda-main-header-content">

                        <div className="sanitaryAgenda-header-icon">
                            <i className="fa fa-calendar-check-o" />
                        </div>

                        <div className="sanitaryAgenda-header-text">
                            <h4>Agenda Sanitaria</h4>
                            <small>
                                Visualiza, organiza y consulta
                                los muestreos programados.
                            </small>
                        </div>

                        <div className="sanitaryAgenda-header-count">
                            <strong>{statistics.total}</strong>
                            <span>Muestreos</span>
                        </div>

                    </div>
                </CardBody>
            </Card>

            <div className="sanitaryAgenda-layout">
                <div className="sanitaryAgenda-calendar-col">
                    <div className="sanitaryAgenda-calendar-panel">
                        <div className="sanitaryAgenda-toolbar">
                            <div className="sanitaryAgenda-toolbar-left">
                                <div className="sanitaryAgenda-navigation">
                                    <button
                                        type="button"
                                        className="sanitaryAgenda-today"
                                        onClick={() => navigate('today')}
                                    >
                                        Hoy
                                    </button>

                                    <button
                                        type="button"
                                        onClick={() => navigate('prev')}
                                        title="Anterior"
                                    >
                                        <i className="fa fa-chevron-left" />
                                    </button>

                                    <button
                                        type="button"
                                        onClick={() => navigate('next')}
                                        title="Siguiente"
                                    >
                                        <i className="fa fa-chevron-right" />
                                    </button>
                                </div>

                                <div className="sanitaryAgenda-search">
                                    <i className="fa fa-search" />

                                    <input
                                        type="text"
                                        value={search}
                                        onChange={e => setSearch(e.target.value)}
                                        placeholder="Buscar cotización o empresa..."
                                    />

                                    {search && (
                                        <button
                                            type="button"
                                            onClick={() => setSearch('')}
                                            title="Limpiar búsqueda"
                                        >
                                            <i className="fa fa-times" />
                                        </button>
                                    )}
                                </div>
                            </div>

                            <h3 className="sanitaryAgenda-toolbar-title">
                                {calendarTitle}
                            </h3>

                            <div className="sanitaryAgenda-views">
                                {views.map(view => (
                                    <button
                                        type="button"
                                        key={view.id}
                                        className={currentView === view.id ? 'active' : ''}
                                        onClick={() => changeView(view.id)}
                                        title={view.text}
                                    >
                                        <i className={`fa ${view.icon}`} />
                                        <span>{view.text}</span>
                                    </button>
                                ))}
                            </div>
                        </div>

                        <div className="sanitaryAgenda-calendar-body">
                            {loading && (
                                <div className="sanitaryAgenda-loading">
                                    <i className="fa fa-spinner fa-spin" />
                                    Cargando muestreos...
                                </div>
                            )}

                            <FullCalendar
                                ref={calendarRef}
                                plugins={[
                                    dayGridPlugin,
                                    timeGridPlugin,
                                    interactionPlugin,
                                    listPlugin
                                ]}
                                initialView="dayGridMonth"
                                locale={esLocale}
                                timeZone="local"
                                firstDay={1}
                                headerToolbar={false}
                                height="100%"
                                fixedWeekCount={false}
                                expandRows={true}
                                handleWindowResize={true}
                                dayMaxEvents={2}
                                dayMaxEventRows={false}
                                moreLinkClick={(info) => {
                                    const selectedDay = info.dateStr || info.date.toISOString().substring(0, 10);
                                    openDayList(selectedDay);
                                    return 'none';
                                }}
                                moreLinkContent={(args) => (
                                    <span className="sanitaryAgenda-more">
                                        +{args.num} más
                                    </span>
                                )}
                                dateClick={(info) => {
                                    openDayList(info.dateStr);
                                }}
                                editable={true}
                                eventStartEditable={true}
                                eventDurationEditable={false}
                                eventAllow={(dropInfo) => !isPastDate(dropInfo.startStr)}
                                dayCellClassNames={(arg) =>
                                    isPastDate(arg.date) ? ['sanitaryAgenda-past-day'] : []
                                }
                                eventDisplay="block"
                                displayEventTime={false}
                                events={filteredEvents}
                                eventOrder="title"
                                eventOrderStrict={true}
                                eventClick={selectEvent}
                                eventDrop={handleEventDrop}
                                eventDidMount={applyEventColor}
                                eventContent={arg =>
                                    arg.view.type.startsWith('list')
                                        ? renderListCard(arg)
                                        : renderEventCard(arg)
                                }
                                noEventsContent="No hay muestreos programados."
                                datesSet={(info) => {

                                    setCalendarTitle(info.view.title);
                                    setCurrentView(info.view.type);

                                    const rango = `${info.startStr}|${info.endStr}`;

                                    if (lastRangeRef.current !== rango) {

                                        lastRangeRef.current = rango;

                                        fetchQuotations(info);
                                    }
                                }}
                            />
                        </div>

                        <div className="sanitaryAgenda-calendar-footer">
                            <span>
                                <i className="fa fa-paint-brush" />
                                Colores por empresa
                            </span>

                            <span>
                                <i className="fa fa-arrows" />
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <SidebarDiary
                sidebarVisible={sidebarVisible}
                closeSidebar={closeSidebar}
                panelMode={panelMode}
                selectedEvent={selectedEvent}
                getEventData={getEventData}
                dayEvents={dayEvents}
                formatLongDate={formatLongDate}
                selectedDate={selectedDate}
                openDetails={openDetails}
                backToList={backToList}
                formatDate={formatDate}
                startSampling={startSampling}
                sanitaryHistorical={sanitaryHistorical}
                loadingHistorical={loadingHistorical}
                historicalError={historicalError}
            />

            <CustomAlertDialogGlobal
                visible={customAlert.visible}
                mode={customAlert.mode}
                type={customAlert.type}
                title={customAlert.title}
                message={customAlert.message}
                buttonText={customAlert.buttonText}
                cancelText={customAlert.cancelText}
                onAccept={customAlert.onAccept}
                onCancel={customAlert.onCancel}
                variant={customAlert.variant || "default"}
                rescheduleData={customAlert.rescheduleData || null}
            />

            {
                //? ALERT GLOBAL
            }

            <ToastAletGlobal
                visible={showToast}
                type={toastType}
                title={toastTitle}
                message={toastMessage}
                onClose={closeToastAlert}
            />
        </div>
    );
};